import { replace } from 'connected-react-router';
import { SagaIterator } from 'redux-saga';
import { put, select } from 'redux-saga/effects';

import { USER_COUNTRY_HEADER } from '../../constants/country';
import { ErrorCodeEnum } from '../../constants/errors';
import { ROUTE_NAMES } from '../../constants/routes';
import { IInitKeys } from '../../types/shipping';
import { ISetWhiteLabelingPayload, TInitFailure } from '../../types/store';
import { buildClaimStepPath } from '../../util/buildPath';
import { setMarketplaceBlocked, setWhiteLabeling } from '../actions/init';
import { selectPassword, selectUserCountryHeaderValue } from '../selectors/init';
import { selectInitKeys } from '../selectors/keys';

export function* prepareAuthHeadersSaga(): Generator<any, any, any> {
  const { allowed_recipient_uid } = yield select(selectInitKeys);
  const authPassword: string = yield select(selectPassword);
  const userCountry: string | null = yield select(selectUserCountryHeaderValue);

  return {
    ...(authPassword ? { 'X-OL-API-KEY': authPassword } : {}),
    ...(allowed_recipient_uid ? { 'X-OL-User': allowed_recipient_uid } : {}),
    ...(userCountry ? { [USER_COUNTRY_HEADER]: userCountry } : {}),
  };
}

export const isAuthChallengeFailure = (failure?: TInitFailure | null): boolean =>
  failure?.status === 401 &&
  (failure?.error_code === ErrorCodeEnum.PasswordRequired || failure?.error_code === ErrorCodeEnum.RequiredTwoFA);

export const isMarketplaceIneligibleFailure = (failure?: TInitFailure | null): boolean =>
  failure?.status === 400 && failure?.error_code === ErrorCodeEnum.UserNotEligibleForMarketplace;

export function* showUsOnlyScreenSaga(failure: TInitFailure): SagaIterator {
  const { ds_customized_texts, org_info, sender_info } = failure;

  if (ds_customized_texts || org_info || sender_info) {
    yield put(setWhiteLabeling({ ds_customized_texts, org_info, sender_info } as ISetWhiteLabelingPayload));
  }

  const keys: IInitKeys = yield select(selectInitKeys);

  yield put(setMarketplaceBlocked());
  yield put(replace(buildClaimStepPath(keys, ROUTE_NAMES.pyg)));
}
